import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { UploadFilesComponent } from './upload-files.component';
import { UploadFileSampleFormatComponent } from './upload-file-sample-format/upload-file-sample-format.component';

@NgModule({
  declarations: [UploadFilesComponent, UploadFileSampleFormatComponent],
  imports: [
    CommonModule,
    DropzoneModule
  ],
  exports: [UploadFilesComponent, UploadFileSampleFormatComponent],
  entryComponents: [UploadFilesComponent, UploadFileSampleFormatComponent]
})
export class UploadFilesModule { }
